<footer class="footer">
  <div class="footer-content">
    <p class="copyright">
      Developed by
      <a class="brand-link" href="https://livex.tv/" target="_blank" rel="noopener noreferrer">Live, X, Inc.</a>
      {{ currentYear }}
    </p>
    <nav class="links" aria-label="Legal">
      <a class="link" routerLink="/license" target="_blank">Terms of Service</a>
      <a class="link" routerLink="/privacy-policy" target="_blank">Privacy Policy</a>
    </nav>
  </div>
</footer>
